import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { StoreProvider } from '../contexts/StoreContext';
import { ProjectsProvider } from '../contexts/ProjectsContext';

import NavigationBar from './NavigationBar';
import ProductDetail from './ProductDetail';
import Footer from './Footer';
import CategoryDetail from './CategoryDetail';
import ProjectDetail from './ProjectDetail';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import FAQ from './FAQ';
import ContactPage from './ContactPage';
import ViewpointPage from './ViewpointPage';
import PricingPage from './PricingPage';
import FilmmakingPricingPage from './FilmmakingPricingPage';
import WhatWeDo from './WhatWeDo';
import GetStartedPage from './GetStartedPage';
import AppDeepLinkPage from './AppDeepLinkPage';
import WebsitePrivacyPolicy from './WebsitePrivacyPolicy';
import WebsiteTermsOfService from './WebsiteTermsOfService';
import AboutPage from './AboutPage';
import ManifestoPage from './ManifestoPage';
import ProductionSuitePage from './ProductionSuitePage';
import ShootYourShotPage from './ShootYourShotPage';
import ScrollToTop from '../components/ScrollToTop';

export default function App() {
  return (
    <StoreProvider>
      <ProjectsProvider>
        <div
          style={{
            padding: '0px',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          {/*
            iOS App Icon Squircle Clip Path
            --------------------------------
            This is the exact iOS app icon shape (continuously cornered rounded
            rectangle) reverse-engineered by Liam Rosenfeld from Apple's
            UIBezierPath(roundedRect:, cornerRadius:) with 0px error against
            Apple's actual mask. The path uses bezier control points computed
            with a 45% corner radius (iOS icon spec) normalized to a 0–1 unit
            square for use with clipPathUnits="objectBoundingBox".

            NOT a superellipse (1365px error) or CSS border-radius (322px error).
            See: https://liamrosenfeld.com/posts/apple_icon_quest/
          */}
          <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
              <clipPath id="squircle-clip" clipPathUnits="objectBoundingBox">
                <path d="M 0.3440,0 L 0.6560,0 C 0.7551,0 0.8046,0 0.8579,0.0169 C 0.9161,0.0380 0.9620,0.0839 0.9831,0.1421 C 1,0.1954 1,0.2449 1,0.3440 L 1,0.6560 C 1,0.7551 1,0.8046 0.9831,0.8579 C 0.9620,0.9161 0.9161,0.9620 0.8579,0.9831 C 0.8046,1 0.7551,1 0.6560,1 L 0.3440,1 C 0.2449,1 0.1954,1 0.1421,0.9831 C 0.0839,0.9620 0.0380,0.9161 0.0169,0.8579 C 0,0.8046 0,0.7551 0,0.6560 L 0,0.3440 C 0,0.2449 0,0.1954 0.0169,0.1421 C 0.0380,0.0839 0.0839,0.0380 0.1421,0.0169 C 0.1954,0 0.2449,0 0.3440,0 Z" />
              </clipPath>
            </defs>
          </svg>
          <ScrollToTop />
          <NavigationBar />
          {/*
            NAV BAR SPACING: The NavigationBar uses position: 'fixed', so it
            overlaps page content. This paddingTop pushes all route content
            below the nav bar. It must match the nav bar's rendered height
            (~80px = 20px vertical padding + ~40px logo).

            IMPORTANT: Individual page views should NOT add their own
            paddingTop for nav clearance — it's handled here globally.
            If you change the nav bar height, update this value to match.
          */}
          <div style={{ flex: 1, paddingTop: '56px' }}>
            <Routes>
              <Route path="/" element={<AboutPage />} />
              <Route path="/viewpoint" element={<ViewpointPage />} />
              <Route path="/business/how-it-works" element={<WhatWeDo />} />
              <Route path="/shoot-your-shot" element={<ShootYourShotPage />} />
              <Route path="/production" element={<ProductionSuitePage />} />
              <Route path="/pricing" element={<FilmmakingPricingPage />} />
              <Route path="/business/pricing" element={<PricingPage />} />
              <Route path="/business/get-started" element={<GetStartedPage />} />
              <Route path="/privacy" element={<WebsitePrivacyPolicy />} />
              <Route path="/terms" element={<WebsiteTermsOfService />} />
              <Route path="/about" element={<Navigate to="/" replace />} />
              <Route path="/manifesto" element={<ManifestoPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="product/:id" element={<ProductDetail />} />
              <Route path="category/:id" element={<CategoryDetail />} />
              <Route path=":id/privacy" element={<PrivacyPolicy />} />
              <Route path=":id/terms" element={<TermsOfService />} />
              <Route path=":id/help" element={<FAQ />} />
              <Route path=":appName/join/:code" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions/:productionId/shots/:shotId" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions/:productionId/shots" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions/:productionId/scenes/:sceneId" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions/:productionId/scenes" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions/:productionId/viewfinder/:photoId" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions/:productionId" element={<AppDeepLinkPage />} />
              <Route path=":appName/productions" element={<AppDeepLinkPage />} />
              <Route path=":id" element={<ProjectDetail />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </ProjectsProvider>
    </StoreProvider>
  );
}
